/* Upsell para Drawer y Página de Carrito (OK Perfumes) — v2.2 (Badge Eliminado) */
(function () {
  var AREAS = [
    { root: '#DrawerUpsell', fallbackId: 'DrawerUpsellFallback', source: 'drawer' },
    { root: '#PageUpsell',   fallbackId: 'PageUpsellFallback',   source: 'page'   }
  ];

  var ATTR_ID = 'data-variant-id';
  var FLAG = 'okpBound';

  function money(cents) {
    try {
      return theme.Currency.formatMoney(cents, theme.settings.moneyFormat);
    } catch (e) {
      var v = (Number(cents) || 0) / 100;
      var loc = document.documentElement.lang || navigator.language || 'es-ES';
      var curr = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
      try { return new Intl.NumberFormat(loc, { style: 'currency', currency: curr }).format(v); }
      catch(_e){ return v.toLocaleString(undefined,{minimumFractionDigits:2, maximumFractionDigits:2}) + ' ' + curr; }
    }
  }

  function pickVariant(p, preselect) {
    if (!p || !p.variants || !p.variants.length) return null;
    var found = preselect ? p.variants.find(function (v) { return v.id === preselect; }) : null;
    if (found && found.available) return found;
    var firstAvail = p.variants.find(function (v) { return v.available; });
    return firstAvail || p.variants[0];
  }

  function imgWith(url, alt){
    var img = new Image();
    img.loading = 'lazy';
    img.decoding = 'async';
    var src = String(url || '');
    img.src = src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=160';
    img.alt = alt || '';
    return img;
  }

  // --- FUNCIÓN card() MODIFICADA (Badge eliminado) ---
  function card(product, variant) {
    var el = document.createElement('article');
    el.className = 'cart-upsell__card';
    el.setAttribute('data-product-id', product.id);

    // Media (Imagen)
    var media = document.createElement('div');
    media.className = 'cart-upsell__media';
    if (variant && (variant.featured_image && variant.featured_image.src ? variant.featured_image.src : variant.featured_image)) {
      media.appendChild(imgWith(variant.featured_image.src || variant.featured_image, product.title));
    } else if (product.featured_image) {
      media.appendChild(imgWith(product.featured_image, product.title));
    }

    // Contenido
    var content = document.createElement('div');
    content.className = 'cart-upsell__content';

    // Nombre del producto
    var name = document.createElement('a');
    name.className = 'cart-upsell__name';
    name.href = '/products/' + product.handle + '?variant=' + variant.id;
    name.textContent = product.title + ((variant && variant.title && variant.title !== 'Default Title') ? (' · ' + variant.title) : '');
    
    // --- [ELIMINADA] Lógica de Badge ---

    // Contenedor de precios
    var priceContainer = document.createElement('div');
    priceContainer.className = 'cart-upsell__price-container';

    var price = document.createElement('span');
    price.className = 'cart-upsell__price';
    price.innerHTML = money(variant ? variant.price : 0);
    priceContainer.appendChild(price);

    // Lógica de precio de comparación
    if (variant && variant.compare_at_price && Number(variant.compare_at_price) > Number(variant.price)) {
      var comparePrice = document.createElement('span');
      comparePrice.className = 'cart-upsell__price cart-upsell__price--compare';
      comparePrice.innerHTML = money(variant.compare_at_price);
      priceContainer.appendChild(comparePrice);
      price.classList.add('cart-upsell__price--on-sale');
    }

    // Botón
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'btn btn--primary btn--small cart-upsell__btn';
    btn.setAttribute(ATTR_ID, variant.id);
    btn.setAttribute('aria-label', 'Añadir “' + name.textContent + '” al carrito');
    btn.setAttribute('aria-busy', 'false');
    btn.setAttribute('aria-disabled', 'false');
    btn.textContent = 'Añadir';

    // Montar el contenido
    content.appendChild(name);
    // [ELIMINADO] Añadir el badge
    content.appendChild(priceContainer);
    content.appendChild(btn);

    // Montar la tarjeta
    el.appendChild(media);
    el.appendChild(content);
    return el;
  }
  // --- FIN FUNCIÓN card() MODIFICADA ---

  function addToCart(variantId, btn, source) {
    if (!variantId) return;
    btn.disabled = true; btn.classList.add('btn--loading');
    btn.setAttribute('aria-busy', 'true'); btn.setAttribute('aria-disabled', 'true');

    var body = 'id=' + encodeURIComponent(variantId) + '&quantity=1'
             + '&properties%5B_upsell_source%5D=' + encodeURIComponent(source);

    fetch((theme && theme.routes && theme.routes.cartAdd) || '/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded', 'X-Requested-With': 'XMLHttpRequest' },
      body: body
    })
    .then(function(r){ return r.json(); })
    .then(function(){
      document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
      document.dispatchEvent(new CustomEvent('cart:build'));
      var live = document.getElementById('okp-upsell-live');
      if (live) live.textContent = 'Producto añadido al carrito.';
    })
    .catch(function(){ /* silencioso */ })
    .finally(function(){
      btn.disabled = false; btn.classList.remove('btn--loading');
      btn.setAttribute('aria-busy', 'false'); btn.setAttribute('aria-disabled', 'false');
    });
  }

  function initArea(cfg) {
    var root = document.querySelector(cfg.root);
    if (!root) return;

    var grid = root.querySelector('[data-upsell-grid]');
    if (!grid) return;

    // Lee fallback JSON incrustado
    var raw = document.getElementById(cfg.fallbackId);
    var list = [];
    try { list = raw ? JSON.parse(raw.textContent) : []; } catch (e) {}

    // Construye hasta N tarjetas
    var max = parseInt(root.getAttribute('data-count') || '3', 10);
    grid.innerHTML = '';

    list.slice(0, max).forEach(function (p) {
      var v = pickVariant(p, p.preselect);
      if (!v) return;
      grid.appendChild(card(p, v));
    });

    // Oculta si no hay nada
    if (!grid.children.length) {
      root.style.display = 'none';
      return;
    } else {
      root.style.display = '';
    }

    // Delegación de clicks (evita duplicados en reinits)
    if (!root.dataset[FLAG]) {
      root.dataset[FLAG] = 'true';
      root.addEventListener('click', function (e) {
        var btn = e.target.closest('.cart-upsell__btn');
        if (!btn) return;
        e.preventDefault();
        addToCart(btn.getAttribute(ATTR_ID), btn, cfg.source);
      });
    }
  }

  function initAll(){ AREAS.forEach(initArea); }

  document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('cart:open',   initAll);
  document.addEventListener('cart:updated',initAll);
  document.addEventListener('ajaxProduct:added', initAll);
})();

